import { React, ts } from '_core';

import Chart from './chart';
import Form from './form';
import { DraftParams, Params } from './types';

type SignalPreviewDateComparisonProps = {
  id: string;
  mode: ts.enums.CHART_MODE_ENUM;
  params: Params | DraftParams;
  setParams: (_p: DraftParams) => void;

  loadWidgetData: (_payload: ts.types.widgets.WidgetGetDataParams) => Promise<ts.types.widgets.WidgetGetDataResponse>;
  widgetPaths?: Record<'signal_date_comparison', string>;
  goFullScreen?: (_b: string) => void;
  fullScreen?: boolean;

  context?: ts.types.signal.SignalAnalysisContext;
  queryParams?: { initial?: string };
};

const SignalPreviewDateComparison = ({
  id,
  loadWidgetData,
  widgetPaths,
  mode,
  context,
  params,
  setParams,
  fullScreen,
  goFullScreen,
  queryParams,
}: SignalPreviewDateComparisonProps) => {
  const renderJobComponent = () => (
    <>
      <Chart
        id={id}
        loadWidgetData={loadWidgetData}
        dateComparison={widgetPaths['signal_date_comparison']}
        fullScreen={fullScreen}
        context={context}
        queryParams={queryParams}
        goFullScreen={goFullScreen}
        params={params as Params}
        setParams={setParams}
      />
    </>
  );

  return (
    <>
      {mode == 'edit' ? (
        <Form
          params={params}
          setParams={setParams}
          signalStartDate={context?.start_date}
          signalEndDate={context?.end_date}
          universeId={context?.universe_id}
        />
      ) : (
        renderJobComponent()
      )}
    </>
  );
};

export default SignalPreviewDateComparison;
